module.exports = __webpack_public_path__ + "img/attention-bg.f634cd47.png";